<template>
  <div>
    <v-row no-gutters class="mb-8 px-8">
      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>

      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
        class="pt-8"
      >
        <div class="d-flex flex-column">
          <div class="d-flex mb-16 pb-8">
            <div class="text-h3 font-weight-light">
              {{ $t('menus.blotter') }}
            </div>
            <v-spacer></v-spacer>
            <!-- <div class="font-weight-light">
              {{ now }}
            </div> -->
          </div>

          <v-card elevation="12" rounded="xl">
            <v-tabs
              color="primary"
              align-with-title
              touchless
              class="rounded-t-xl elevation-12"
            >
              <v-tab
                style="width: 160px; margin-left: 0px;"
              >
                <v-icon 
                  style="margin-top: 2px;" 
                  small 
                  class="mr-3"
                  :color="isRealtime ? 'red' : 'grey lighten-1'"
                >
                  mdi-circle-slice-8
                </v-icon>
                Real Time
              </v-tab>

              <v-spacer></v-spacer>

              <div>
                <v-menu
                  offset-y
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      text
                      rounded
                      style="font-size: 12px"
                      class="mt-2 mr-5"
                    >
                      <span class="mr-2">Hide Columns</span>
                      <v-icon dense color="primary">
                        mdi-filter-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-card class="px-2">
                    <v-checkbox
                      v-for="column in allHeaders"
                      :key="column.text"
                      class="mb-n10 checkbox" 
                      :label="column.text"
                      :disabled="column.locked"
                      :value="column.text"
                      v-model="hiddenColumns"
                    >
                    </v-checkbox>
                  </v-card>
                </v-menu>
              </div>
            </v-tabs>
            <v-data-table
              :headers="tableHeaders"
              :items="tableItems"
              hide-default-footer
            >
            <template v-slot:[`item.rfq_status`]="{ item }">
              <span 
                :style="{
                  color: item.rfq_status === 'DEAL' ? '#00E676' 
                        : item.rfq_status === 'REJECTED' ? '#ED2B2A' 
                        : 'inherit',
                  fontWeight: 'bold',
                  textTransform: 'uppercase'
                }"
              >
                {{ item.rfq_status }}
              </span>
            </template>
            <template v-slot:[`item.rfq_id`]="{ item }">
              <span>
                {{ item.rfq_id ? item.rfq_id.slice(0, 6) + '...' : '' }}
              </span>
            </template>

            </v-data-table>
          </v-card>

        </div>
      </v-col>

      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useDisplayStore, useAutopricerStore } from "./../store/index"
import { mapState, mapActions } from "pinia";
import * as utils from "./../utils.js"

export default {
  components: {
  },
  data () {
    return {
      isRealtime: false,
      hiddenColumns: [],
      tableItems: [],
    }
  },
  computed: {
    ...mapState(useDisplayStore, [
      "isXSmall",
      "isSmall",
      "isMedium",
      "isLarge",
      "isXLarge"
    ]),
    now () {
      return utils.formatTimeAndDate(false)
    },
    allHeaders () {
      const headers = [
        { text: "RFQ Time", value: "rfq_timestamp_s", locked: true, class: "pl-6" },
        { text: "RFQ Status", value: "rfq_status", locked: true },
        { text: "Counterparty", value: "counterparty_name", locked: true },
        { text: "CCY", value: "rfq_ccy", locked: true },
        { text: "Order Symbol", value: "rfq_symbol", locked: true },
        { text: "Amount CCY", value: "rfq_orderqty", locked: true },
        { text: "Buy/Sell", value: "rfq_side", locked: true },
        { text: "Spot", value: "rfq_px", locked: true },
        // { text: "Spread (bps)", value: "spread_bps", locked: true },
        // { text: "Revenue (BRL)", value: "revenue_brl", locked: true },
        // { text: "Sett BRL/CCY", value: "rfq_sett", locked: true },
        { text: "RFQ ID", value: "rfq_id" },
        // { text: "Channel", value: "channel" }
      ]
      return headers.map(h => ({ ...h, align: "center", sortable: false,  }))
    },
    tableHeaders () {
      return this.allHeaders.filter(h => !this.hiddenColumns.includes(h.text))
    }
  },
  mounted () {
    const bankId = localStorage.getItem('bankId')
    this.getRfqs(bankId)
      .then(response => this.loadBlotterData(response.data))
      .catch(console.log)

    // polling a cada 3s
    this.interval = setInterval(() => {
      this.getRfqs(bankId)
        .then(response => this.loadBlotterData(response.data))
        .catch(console.log)
    }, 3000)
  },
  beforeDestroy () { // use "beforeUnmount" se Vue 3
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    ...mapActions(useAutopricerStore, [
      "getRfqs"
    ]),
    loadBlotterData(rawData) {
      this.tableItems = rawData.map(item => {
        return {
          rfq_id: item.rfq_id || '—',
          rfq_orderqty: item.rfq_orderqty,
          rfq_symbol: item.rfq_symbol || '—',
          rfq_ccy: item.rfq_ccy || '—',
          rfq_status: item.rfq_status || '—',
          rfq_side: item.rfq_side ? item.rfq_side.toUpperCase() : '—',
          rfq_px: !isNaN(Number(item.rfq_px)) ? Number(item.rfq_px).toFixed(4) : '—',
          rfq_timestamp_s: item.rfq_timestamp_s || '—',
          rfq_sett: item.rfq_sett || '—',
          counterparty_name: item.counterparty_name || '—',
          // spread_bps: item.spread_bps !== undefined ? item.spread_bps : '—',
          // revenue_brl: item.revenue_brl !== undefined ? item.revenue_brl : '—',
          // channel: item.rfq_id?.startsWith("BLP") ? "Bloomberg" : "API" || '—'
        }
      })

      const missing = 10 - this.tableItems.length
      if (missing > 0) {
        const emptyRow = {}
        this.tableHeaders.forEach(h => {
          emptyRow[h.value] = ''
        })
        this.tableItems.push(...Array.from({ length: missing }, () => ({ ...emptyRow })))
      }
    }
  }
}
</script>

<style scoped>

.checkbox >>> .v-label {
  font-size: 12px;
}

</style>
